import ActivityContainer from './ActivityContainer'

export default ActivityContainer
